import React,{ useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router';

import {urlBase} from "../config/Globals";

import {Partenaires} from "./Home/Partenaires";
import ArticleService from "../service/Article";
import ArticleLutteService from "../service/ArticleLutteService";
import FaqService from "../service/Faq";
import maison from "../assets/images/maison.svg";

export const Recherche = () => {

    const { search } = useParams();

    const[articles, setArticles] = useState([]);
    const[loadingArticles, setLoadingArticles] = useState(1);
    const fetchArticles = async(search) => {
        try {
            setLoadingArticles(true);
            const data = await ArticleService.search(search);
            setArticles(data);
        } catch (error) {
            console.error("Erreur lors de la récup des articles", error);
        } finally {
            setLoadingArticles(false);
        }
    }
    useEffect(() => {
        if (search) {
            fetchArticles(search);
        }
    }, [search]);

    const[articlesLutte, setArticlesLutte] = useState([]);
    const[loadingArticlesLutte, setLoadingArticlesLutte] = useState(1);
    const fetchArticlesLutte = async(search) => {
        try {
            setLoadingArticlesLutte(true);
            const data = await ArticleLutteService.search(search);
            setArticlesLutte(data);
        } catch (error) {
            console.error("Erreur lors de la récup des articlesLutte", error);
        } finally {
            setLoadingArticlesLutte(false);
        }
    }
    useEffect(() => {
        if (search) {
            fetchArticlesLutte(search);
        }
    }, [search]);

    const[faqs, setFaqs] = useState([]);
    const[loadingFaqs, setLoadingFaqs] = useState(1);
    const fetchFaqs = async(search) => {
        try {
            setLoadingFaqs(true);
            const data = await FaqService.search(search);
            setFaqs(data);
        } catch (error) {
            console.error("Erreur lors de la récup des Faqs", error);
        } finally {
            setLoadingFaqs(false);
        }
    }
    useEffect(() => {
        if (search) {
            fetchFaqs(search);
        }
    }, [search]);


    return (
        <>
            <Helmet>
                <title>Résultats de votre recherche {search}</title>
                <meta name="description" content={"Résultats de votre recherche "+search} />
            </Helmet>
            <main className="type">
                <section className="pt-md-5 pt-lg-0 pb-md-5 vh-90-desktop d-flex align-items-center">
                    <div className="bg-cover-2 d-none d-md-block"></div>
                    <div className="container-md px-md-4 pb-md-5 position-relative z-1">
                        <div className="row flex-column align-items-center justify-content-center">
                            <div className="col-12 col-lg-10 col-xl-8 bg-white pb-5 p-4 p-md-5">

                                <div className="col-12">
                                    <nav aria-label="breadcrumb" className="mb-4">
                                        <ol className="custom-breadcrumb">
                                            <li className="breadcrumb-item-custom">
                                                <a href="/" className="breadcrumb-link-home">
                                                    <img src={maison} alt="Accueil" className="breadcrumb-icon"/>
                                                </a>
                                            </li>
                                            <li className="breadcrumb-separator">•</li>
                                            <li className="breadcrumb-item-custom active" aria-current="page">
                                                Résultats de recherche
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                                <div className="col-12 d-flex gap-3 align-items-center">
                                    <h1 className="text-dark fs-4 fw-sb mb-4">Vous avez recherché : {search}</h1>
                                </div>
                                {
                                    articles.map((article,index) => (
                                        <div key={article.id} className="col-12 d-flex gap-3 align-items-center">
                                        <div className="col-12 mb-3">
                                            <div className="col-12 bg-gris px-3 py-2 d-flex justify-content-between align-items-center">
                                                <span className="fw-sb">{article.titre}</span>
                                                <a
                                                    href={`${urlBase}tout-savoir-sur-la-flavescence-doree${article.id_rubrique.id == '3849d958-61dc-4b2b-9371-94bfc5c9691e' ? '/plus' : ''}/${article.id_rubrique.wording}/${article.id}`}
                                                    className="btn btn-mini btn-outline-custom">Voir</a>
                                            </div>
                                        </div>

                                        </div>
                                    ))
                                }
                                {
                                    articlesLutte.map((article,index) => (
                                        <div key={article.id} className="col-12 d-flex gap-3 align-items-center">
                                            <div className="col-12 mb-3">
                                                <div className="col-12 bg-gris px-3 py-2 d-flex justify-content-between align-items-center">
                                                    <span className="fw-sb">{article.titre}</span>
                                                    <a
                                                        href={`${urlBase}tout-savoir-sur-la-flavescence-doree/organisation-de-la-lutte/${article.pilier_lutte.wording}`}
                                                        className="btn btn-mini btn-outline-custom">Voir</a>
                                                </div>
                                            </div>

                                        </div>
                                    ))
                                }
                                {
                                    faqs.map((article,index) => (
                                        <div key={article.id} className="col-12 d-flex gap-3 align-items-center">
                                            <div className="col-12 mb-3">
                                                <div className="col-12 bg-gris px-3 py-2 d-flex justify-content-between align-items-center">
                                                    <span className="fw-sb">{article.titre}</span>
                                                    <a
                                                        href={`${urlBase}faq/${article.categorie[0].categorie_faq_id}`}
                                                        className="btn btn-mini btn-outline-custom">Voir</a>
                                                </div>
                                            </div>

                                        </div>
                                    ))
                                }
                                {articles.length === 0 && articlesLutte.length === 0 && faqs.length === 0 && (
                                    <div className="col-12 text-center py-4">
                                        <p className="text-muted fs-5">Aucun résultat ne correspond à votre recherche.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
                <Partenaires />
            </main>
        </>
    )
}